import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2405a36&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e2405a36&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2405a36",
  null
  
)

export default component.exports